import React, { useState } from 'react';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

/**
 * Componente CustomSelect
 * Props:
 * - options: array de strings ou objetos { value, label }
 * - value: valor selecionado
 * - onChange: função chamada ao mudar (recebe string)
 * - placeholder: texto placeholder
 * - dragAndDrop: boolean para ativar drag and drop (default: false)
 * - inputProps: props extras para o input
 * - listId: id do datalist
 */
export const CustomSelect = ({
    options = [],
    value = '',
    onChange,
    placeholder = '',
    dragAndDrop = false,
    inputProps = {},
    listId = 'custom-select-list',
}) => {
    const [dragOverType, setDragOverType] = useState(null); // null | 'variavel' | 'node'

    // Handlers internos de drag and drop
    const handleDragOver = (e) => {
        if (!dragAndDrop) return;
        e.preventDefault();
        const isVar = !!e.dataTransfer.types.find(t => t === 'application/variavel');
        setDragOverType(isVar ? 'variavel' : 'node');
    };
    const handleDragLeave = () => {
        if (!dragAndDrop) return;
        setDragOverType(null);
    };
    const handleDrop = (e) => {
        if (!dragAndDrop) return;
        e.preventDefault();
        const data = e.dataTransfer.getData('application/variavel');
        if (!data) {
            setDragOverType(null);
            return;
        }
        const v = JSON.parse(data);
        onChange && onChange({ target: { value: v.nome } });
        setDragOverType(null);
    };

    // Handler de mudança
    const handleChange = (e) => {
        onChange && onChange(e);
    };

    return (
        <div style={{ position: 'relative', width: '100%' }}>
            <datalist id={listId}>
                {options.map((opt, idx) => {
                    if (typeof opt === 'string') return <option key={idx} value={opt} />;
                    return <option key={idx} value={opt.value}>{opt.label || opt.value}</option>;
                })}
            </datalist>
            <input
                type="text"
                list={listId}
                value={value}
                onChange={handleChange}
                placeholder={placeholder}
                onDragOver={dragAndDrop ? handleDragOver : undefined}
                onDragLeave={dragAndDrop ? handleDragLeave : undefined}
                onDrop={dragAndDrop ? handleDrop : undefined}
                style={{ width: '100%', padding: '5px', marginTop: '4px' }}
                {...inputProps}
            />
            {dragAndDrop && dragOverType === 'variavel' && (
                <CheckCircleIcon style={{ position: 'absolute', top: 7, right: 2, color: 'green', fontSize: 22, zIndex: 2 }} />
            )}
            {dragAndDrop && dragOverType === 'node' && (
                <CancelIcon style={{ position: 'absolute', top: 7, right: 2, color: 'red', fontSize: 22, zIndex: 2 }} />
            )}
        </div>
    );
};
